import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const Group = makeShortcode("Group");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Item title='paymentMethodTokenData' subtitle='PrimerPaymentMethodTokenData' mdxType="Item">
	<Group summary='parameters' open mdxType="Group">
		<Item title='analyticsId' subtitle='String' mdxType="Item"></Item>
		<Item title='id' subtitle='String' mdxType="Item"></Item>
		<Item title='paymentInstrumentData' subtitle='PaymentInstrumentData' mdxType="Item">
			<Group summary='parameters' open mdxType="Group">
				<Item title='paymentMethodConfigId' subtitle='String' mdxType="Item"></Item>
				<Item title='paymentMethodType' subtitle='String' mdxType="Item"></Item>
				<Item title='sessionInfo' subtitle='SessionInfo' mdxType="Item"></Item>
				<Item title='first6Digits' subtitle='String' mdxType="Item"></Item>
				<Item title='last4Digits' subtitle='String' mdxType="Item"></Item>
        <Item title='accountNumberLast4Digits' subtitle='String' mdxType="Item"></Item>
				<Item title='expirationMonth' subtitle='String' mdxType="Item"></Item>
				<Item title='expirationYear' subtitle='String' mdxType="Item"></Item>
				<Item title='cardholderName' subtitle='String' mdxType="Item"></Item>
				<Item title='network' subtitle='String' mdxType="Item"></Item>
				<Item title='isNetworkTokenized' subtitle='String' mdxType="Item"></Item>
				<Item title='binData' subtitle='BinData' mdxType="Item"></Item>
				<Item title='threeDSecureAuthentication' subtitle='ThreeDS.AuthenticationDetails' mdxType="Item"></Item>
				<Item title='paypalBillingAgreementId' subtitle='String' mdxType="Item"></Item>
				<Item title='externalPayerInfo' subtitle='ExternalPayerInfo' mdxType="Item">
          Additional Paypal data.
          <Group summary='Properties' open mdxType="Group">
            <Item title='email' subtitle='String' mdxType="Item">
                 The payer's email address.
            </Item>
            <Item title='externalPayerId' subtitle='String?' mdxType="Item">
              The payer's unique ID.
            </Item>
            <Item title='firstName' subtitle='String?' mdxType="Item">
              The payer's given name.
            </Item>
            <Item title='lastName' subtitle='String?' mdxType="Item">
              The payer's given surname.
            </Item>
          </Group>
        </Item>
        <Item title='shippingAddress' subtitle='ShippingAddress' mdxType="Item"></Item>
        <Item title='klarnaCustomerToken' subtitle='String' mdxType="Item"></Item>
        <Item title='sessionData' subtitle='SessionData' mdxType="Item"></Item>
        <Item title='bankName' subtitle='String' mdxType="Item"></Item>
     </Group>
		</Item>
		<Item title='paymentInstrumentType' subtitle='PaymentInstrumentType' mdxType="Item">
			<Group summary='cases' open mdxType="Group">
				<Item title='paymentCard' mdxType="Item"></Item>
				<Item title='offSession' mdxType="Item"></Item>
				<Item title='cardOffSession' mdxType="Item"></Item>
				<Item title='payPalOrder' mdxType="Item"></Item>
				<Item title='payPalBillingAgreement' mdxType="Item"></Item>
				<Item title='applePay' mdxType="Item"></Item>
				<Item title='googlePay' mdxType="Item"></Item>
				<Item title='klarna' mdxType="Item"></Item>
				<Item title='klarnaPaymentSession' mdxType="Item"></Item>
				<Item title='klarnaCustomerToken' mdxType="Item"></Item>
				<Item title='apayaToken' mdxType="Item"></Item>
				<Item title='hoolah' mdxType="Item"></Item>
				<Item title='unknown' mdxType="Item"></Item>
			</Group>
		</Item>
		<Item title='threeDSecureAuthentication' subtitle='ThreeDS.AuthenticationDetails' mdxType="Item"></Item>
		<Item title='token' subtitle='String' label='Required' mdxType="Item"></Item>
		<Item title='tokenType' subtitle='TokenType' mdxType="Item">
			<Group summary='cases' open mdxType="Group">
				<Item title='multiUse' mdxType="Item"></Item>
				<Item title='singleUse' mdxType="Item"></Item>
			</Group>
		</Item>
		<Item title='vaultData' subtitle='VaultData' mdxType="Item"></Item>
	</Group>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      